import LoginForm from '../../components/LoginForm';
import { useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useAuthStore } from '../../store';

const LoginPage = () => {
  const { user } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/', { replace: true });
    }
  }, [navigate, user]);

  return (
    <div className="flex h-screen bg-white items-center">
      <div className={'flex items-center w-3/5 h-screen bg-[#A33332] p-4'}>
        <span className={'text-white font-bold m-0 font-hansom'}>
          ASIA CERAMICS CORPORATION
          <img
            src={'/mmd/login-image.png'}
            alt={'asia-ceramic.png'}
            width={1200}
            height={120}
          />
        </span>
      </div>
      <div
        className={
          'flex flex-col justify-center items-center bg-white h-screen w-2/5 p-4'
        }
      >
        <img
          src={'/mmd/mmd.png'}
          alt={'mmd.png'}
          height={50}
          width={50}
          className={'w-auto h-auto'}
        />
        <h2 className={'font-hansom font-semibold '}>Welcome Back!</h2>
        <p className={'text-xs'}>
          Enter your username and password to continue
        </p>
        <div className={'pt-14'}>
          <LoginForm />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
